import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {IntegrationDao} from "../../../../core/services/dao/integrationDao";
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {User} from "../../../../core/models/user";
import {IntegrationInvite} from "../../../../core/models/integrationInvite";
import {UntypedFormBuilder, Validators} from '@angular/forms';

export enum SelectedSection {
  NONE,
  OPTION_1,
  OPTION_2,
  OPTION_3
}

@Component({
  selector: 'app-s3',
  templateUrl: './s3.component.html',
  styleUrls: ['./s3.component.scss']
})
export class S3Component implements OnInit, OnDestroy {
  int = { type: 's3' } as any;
  error = false;
  loading = true;
  existingIntegrations = [];
  creating = false;
  user: User;
  invites: IntegrationInvite[];
  description: string = '';
  showAccounts = false;
  integrationName;
  integrationType;
  noAccounts = false;
  isAdmin = false;
  emitter: EventEmitter<any>;
  status = SelectedSection.OPTION_1;
  form1: any;
  form2: any;
  form3: any;

  private subs: Array<Subscription> = [];

  readonly ROLE_ARN : string = 'arn:aws:iam::737238977145:role/advocado-external-s3';
  readonly ACCOUNT_ID : string = '737238977145:role/advocado-external-s3';

  constructor(
      public dialogRef: MatDialogRef<S3Component>,
      public integrationDao: IntegrationDao,
      private fb: UntypedFormBuilder,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.existingIntegrations = this.data.existingIntegrations;
    this.user = this.data.user;
    this.isAdmin = this.user ? this.user.isAdmin : false;
    this.invites = this.data.invites;
    this.description = this.data.description;
    this.integrationName = this.data.name;
    this.integrationType = this.data.type;
    this.emitter = this.data.emitter;
    if (this.existingIntegrations.length === 0) {
      this.creating = true;
    }
  }

  ngOnInit(): void {
    this.int.brand = this.data.brand;
    this.loading = false;

    this.form1 = this.fb.group({
      friendlyName: ['', { validators: [Validators.required], updateOn: 'change' }],
      accessKeyId: ['', { validators: [Validators.required], updateOn: 'change' }],
      secretAccessKey: ['', { validators: [Validators.required], updateOn: 'change' }],
      region: ['', { validators: [Validators.required], updateOn: 'change' }],
      bucketName: ['', { validators: [Validators.required], updateOn: 'change' }]
    });

    this.form2 = this.fb.group({
      bucketArn: ['', { validators: [Validators.required], updateOn: 'change' }]
    });

    this.form3 = this.fb.group({
      bucketArn: ['', { validators: [Validators.required], updateOn: 'change' }],
      roleArn: ['', { validators: [Validators.required], updateOn: 'change' }]
    });
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onViewInvitesClick() {
    this.emitter.emit(this.integrationType);
    this.dialogRef.close();
  }

  addAnother(e) {
    this.creating = true;
  }

  toggleShowAccounts() {
    this.showAccounts = !this.showAccounts;
  }

  create(e) {
    this.loading = true;
    let temp = { ...this.int };

    // build int object
    switch (this.status) {
      case 1:
        temp['connectionMethod'] = 'accessKeys';
        temp['friendlyName'] = this.form1.value.friendlyName;
        temp['accessKeyId'] = this.form1.value.accessKeyId;
        temp['secretAccessKey'] = this.form1.value.secretAccessKey;
        temp['region'] = this.form1.value.region;
        temp['bucketName'] = this.form1.value.bucketName;
        break;
      case 2:
        temp['connectionMethod'] = 'caBucket';
        temp['bucketArn'] = this.form2.value.bucketArn;
        break;
      case 3:
        temp['connectionMethod'] = 'caRole';
        temp['bucketArn'] = this.form3.value.bucketArn;
        temp['roleArn'] = this.form3.value.roleArn;
        break;
      case 0:
      default:
    }

    // let sub = this.integrationDao.createS3(temp).subscribe(
    //     res => {
    //       if (!res) {
    //         this.error = true;
    //         this.loading = false;
    //         this.dialogRef.close();
    //       } else {
    //         this.error = false;
    //         this.dialogRef.close(res);
    //       }
    //     },
    //     err => console.error(err)
    // );
    // this.subs.push(sub);
  }

  toggleCollapse(enumValue) {
    // if the toggled section is already selected, we set the value to NONE
    if (enumValue === this.status) {
      this.status = SelectedSection.NONE;
    } else {
      this.status = enumValue;
    }
  }

  submitDisabled(): boolean {
    switch (this.status) {
      case SelectedSection.NONE:
        return true;
      case SelectedSection.OPTION_1:
        return this.form1.status === 'INVALID';
      case SelectedSection.OPTION_2:
        return this.form2.status === 'INVALID';
      case SelectedSection.OPTION_3:
        return this.form3.status === 'INVALID';
      default:
        return true;
    }
  }

  copyToClipboard(value) {
    navigator.clipboard.writeText(value);
  }
}
